module.exports = __webpack_public_path__ + "static/media/scoby.670f03b2.png";